const AUTH_NO_KICK = new Set(['/auth/login', '/auth/lost', '/auth/me', '/auth/logout', '/auth/app/retomar']);

export function getApiBaseUrl() {
  const fromEnv = import.meta.env.VITE_API_BASE_URL;
  if (fromEnv) return String(fromEnv).replace(/\/+$/, '');
  return 'https://api.torredecontrole.org';
}

export function apiErrorMessage(data, fallback = 'Falha na autenticação.') {
  return (
    data?.errors?.[0]?.message ||
    data?.error?.message ||
    data?.message ||
    data?.title ||
    fallback
  );
}

function shouldKickToLogin(path, status) {
  if (status !== 401) return false;
  return !AUTH_NO_KICK.has(path.split('?')[0]);
}

export async function apiRequest(path, options = {}) {
  const { token: _ignoredToken, ...rest } = options;
  const headers = {
    'Content-Type': 'application/json',
    ...(rest.headers || {}),
  };
  delete headers.Authorization;

  let response;
  try {
    response = await fetch(`${getApiBaseUrl()}${path}`, {
      ...rest,
      credentials: 'include',
      headers,
    });
  } catch {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('torre:rede', { detail: { offline: true } }));
    }
    const error = new Error('Sem conexão com a internet.');
    error.offline = true;
    error.status = 0;
    throw error;
  }

  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok || data?.success === false) {
    if (shouldKickToLogin(path, response.status) && typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('torre:unauthorized'));
    }
    let fallback = 'Não foi possível concluir agora.';
    if (response.status === 401) fallback = 'Sua sessão expirou. Entre de novo.';
    if (response.status === 403) fallback = 'Você não tem acesso a isso.';
    if (response.status >= 500) fallback = 'A Torre não respondeu. Tente de novo em instantes.';
    const error = new Error(apiErrorMessage(data, fallback));
    error.status = response.status;
    error.data = data;
    throw error;
  }

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('torre:rede', { detail: { offline: false } }));
  }

  return data;
}
